import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

import countries from "./countries";

const TOP = [
  "ec",
  "co",
  "ar",
  "br",
  "cl",
  "uy",
  "pe",
  "py",
  "bo",
  "ve",
].sort();

const Country = (props) => {
  const { t, i18n } = useTranslation();

  // Bug real (auditoría 2026-08-14): countries.sort(...) ordenaba EN EL
  // LUGAR el array importado — compartido por TODA la app — en cada render
  // de cualquier <Country>, mutando el módulo. Además, sin memoizar,
  // recalculaba el sort + ~250 traducciones i18n en cada render sin motivo
  // (el resultado no cambia mientras no cambie el idioma). Se ordena una
  // COPIA y se memoiza por idioma.
  const options = useMemo(
    () =>
      [...countries]
        .sort((a, b) => {
          if (TOP.includes(a) && !TOP.includes(b)) return -1;
          if (!TOP.includes(a) && TOP.includes(b)) return 1;
          return 0;
        })
        .map((value) => ({ value, label: t(`country_${value}`) })),
    [t, i18n.language]
  );

  return (
    <Select
      isClearable
      value={options.find((o) => o.value === props.value)}
      onChange={(country) => props.onChange(country?.value)}
      options={options}
      placeholder={props.placeholder || t(`country_placeholder`)}
    />
  );
};

export default Country;
